export const colorPalette = {
  'purple-100': '#e2d3fe',
  'purple-200': '#c5a7fd',
  'purple-300': '#b692fd',
  'purple-400': '#a77cfc',
  'purple-500': '#8a50fb',
  'purple-600': '#6d24fa',
  'purple-700': '#5a1ad6',
  'purple-800': '#411696',
  'purple-900': '#2c0e64',
  'blue-100': '#F4F7FF',
  'blue-200': '#e4e9ff',
  'blue-300': '#c8d3ff',
  'blue-400': '#adbdff',
  'blue-500': '#849cff',
  'blue-600': '#7691ff',
  'blue-700': '#4f6de8',
  'blue-800': '#3e56b8',
  'blue-900': '#2f3a66',
  'red-100': '#FCE6E7',
  'red-200': '#fbbbbd',
  'red-300': '#f9999c',
  'red-400': '#f7777b',
  'red-500': '#f5555a',
  'red-600': '#c44448',
  'red-700': '#933336',
  'red-800': '#622224',
  'red-900': '#311112',
  'green-100': '#e4f2e4',
  'green-200': '#cae5c9',
  'green-300': '#afd8ae',
  'green-400': '#95cb93',
  'green-500': '#7abe78',
  'green-600': '#629860',
  'green-700': '#497248',
  'green-800': '#314c30',
  'green-900': '#182618',
  'yellow-100': '#fdf7dd',
  'yellow-200': '#fdf4d2',
  'yellow-300': '#fbeebc',
  'yellow-400': '#fae9a5',
  'yellow-500': '#f9e38f',
  'yellow-600': '#e0cc81',
  'yellow-700': '#c7b672',
  'yellow-800': '#ae9f64',
  'yellow-900': '#958856',
  'orange-100': '#fbecde',
  'orange-200': '#efb377',
  'orange-300': '#eda963',
  'orange-400': '#ea9e50',
  'orange-500': '#e8933c',
  'orange-600': '#d18436',
  'orange-700': '#ba7630',
  'orange-800': '#a2672a',
  'orange-900': '#8b5824',
  'grey-100': '#fafafa',
  'grey-200': '#f9f9f9',
  'grey-300': '#f3f5f7',
  'grey-400': '#f1f1f1',
  'grey-500': '#e5eaee',
  'grey-600': '#e0e1e8',
  'grey-700': '#cccfde',
  'grey-800': '#c1c4d3',
  'grey-900': '#909ba8',
  black: '#282838',
  white: '#ffffff'
};
export const UIColorVariables = {
  primary: colorPalette['purple-600'],
  'primary-darken': colorPalette['purple-700'],
  secondary: colorPalette['blue-600'],
  'secondary-darken': colorPalette['blue-700'],
  success: colorPalette['green-500'],
  'success-darken': colorPalette['green-600'],
  danger: colorPalette['red-500'],
  'danger-darken': colorPalette['red-600'],
  warning: colorPalette['yellow-300'],
  'warning-darken': colorPalette['yellow-500'],
  pending: colorPalette['orange-500'],
  'pending-darken': colorPalette['orange-700'],
  'text-primary': colorPalette['black'],
  'text-secondary': colorPalette['grey-900'],
  'text-ghost': colorPalette['grey-700'],
  'bg-grey-whitish': colorPalette['grey-100'],
  'bg-grey-light': colorPalette['grey-200'],
  'bg-grey-bluish': colorPalette['grey-300'],
  'bg-grey-darken': colorPalette['grey-600'],
  'bg-transparent-black': 'rgba(10, 10, 40, 0.8)',
  'border-light': colorPalette['grey-400'],
  'border-default': colorPalette['grey-500'],
  'border-darken': colorPalette['grey-800'],
  transparent: 'transparent'
};
export default { ...UIColorVariables,
  ...colorPalette
};